var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPayment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "btn_taxes_and_commision24x24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10752",
    "data-name": "Rectangle 10752",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-filled-money-tool",
    transform: "translate(4 -13.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28688",
    "data-name": "Group 28688",
    transform: "translate(0 17.84)",
    fill: "#116984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47659",
    "data-name": "Path 47659",
    d: "M160.373,20.886l6.378-1.814-.338-.711a.883.883,0,0,0-1.2-.423l-5.71,2.948Z",
    transform: "translate(-156.634 -17.84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47660",
    "data-name": "Path 47660",
    d: "M328.312,86.46a.864.864,0,0,0-.237.034l-1.5.427L322,88.221h7.458l-.28-1.071A.9.9,0,0,0,328.312,86.46Z",
    transform: "translate(-316.214 -85.176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47661",
    "data-name": "Path 47661",
    d: "M14.18,215.56H.9a.884.884,0,0,0-.7.352.952.952,0,0,0-.165.339A1.007,1.007,0,0,0,0,216.5v10.427a.918.918,0,0,0,.9.936h13.28a.918.918,0,0,0,.9-.936v-2.611H9.746a1.561,1.561,0,0,1-1.527-1.591V220.64a1.619,1.619,0,0,1,.433-1.108,1.49,1.49,0,0,1,.911-.47,1.456,1.456,0,0,1,.181-.011h5.333V216.5A.915.915,0,0,0,14.18,215.56Z",
    transform: "translate(0 -211.859)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47662",
    "data-name": "Path 47662",
    d: "M499.26,437.006a.875.875,0,0,0-.606-.245H493.3a.918.918,0,0,0-.9.936v2.083a.918.918,0,0,0,.9.936h5.356a.882.882,0,0,0,.291-.051.865.865,0,0,0,.314-.195.95.95,0,0,0,.293-.691V437.7A.951.951,0,0,0,499.26,437.006Zm-4.086,1.919a.459.459,0,0,1-.449.468h-.3a.459.459,0,0,1-.449-.468v-.311a.465.465,0,0,1,.172-.367.443.443,0,0,1,.277-.1h.3a.459.459,0,0,1,.449.468v.311Z",
    transform: "translate(-483.553 -428.92)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPayment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_payment.f6df21c21c7da41f8f8155f86d4d2957.svg";